import styled from 'styled-components';

import { buildSrc, useWgllPath } from './helpers';

const StyledIframe = styled.iframe`
  height: calc(100vh - var(--headerOffset));
  width: 100%;
  overflow-y: auto;
  border: none;
`;

export const WgllLibrary: React.FC = () => {
  const path = useWgllPath('LIBRARY');
  return <StyledIframe allowFullScreen src={buildSrc(path)} title="WGLL Library" />;
};

export const OrgReadiness: React.FC = () => {
  const path = useWgllPath('ORG_READINESS');
  return <StyledIframe allowFullScreen src={buildSrc(path)} title="Org Readiness" />;
};
